export default __webpack_public_path__ + "static/BgImg01-f93aa61025feee72ee1137a5733b5d63.webp";